import React from 'react';
import './Cucuta.css'; 

const Cucuta = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKCC.pdf" target="_blank" rel="noreferrer">Aeropuerto Camilo Daza</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontainerCUC'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 16</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3A.pdf" target="_blank" rel="noreferrer">ESNU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC4C.pdf" target="_blank" rel="noreferrer">CUC4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC4C.pdf" target="_blank" rel="noreferrer">TORA2J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI5B.pdf" target="_blank" rel="noreferrer">DIMI5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI5B.pdf" target="_blank" rel="noreferrer">TIBU5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI5B.pdf" target="_blank" rel="noreferrer">TORA2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/UMPE2B.pdf" target="_blank" rel="noreferrer">UMPE2C</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 34</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI7A.pdf" target="_blank" rel="noreferrer">DIMI7A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI7A.pdf" target="_blank" rel="noreferrer">TIBU7A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI7A.pdf" target="_blank" rel="noreferrer">TORA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC4D.pdf" target="_blank" rel="noreferrer">CUC4D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC4D.pdf" target="_blank" rel="noreferrer">TORA2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/UMPE1D.pdf" target="_blank" rel="noreferrer">UMPE1E</a></th>
          </tr>
          
        
          </table>
        </div> 
      </div>

      <div className='subcontainerCUC'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 16</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3A.pdf" target="_blank" rel="noreferrer">ESNU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3B.pdf" target="_blank" rel="noreferrer">ESNU3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3B.pdf" target="_blank" rel="noreferrer">UMPE2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">DIMI2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">LUCH2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">TIBU2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3K.pdf" target="_blank" rel="noreferrer">ESNU3K</a></th>
          </tr>
          
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 34</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3A.pdf" target="_blank" rel="noreferrer">ESNU3A</a></th>
          </tr>
            <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3B.pdf" target="_blank" rel="noreferrer">ESNU3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3B.pdf" target="_blank" rel="noreferrer">UMPE2A</a></th>
          </tr>
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">DIMI2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">LUCH2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">TIBU2F</a></th>
          </tr>
            <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">DIMI2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">LUCH2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2F.pdf" target="_blank" rel="noreferrer">TIBU2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3K.pdf" target="_blank" rel="noreferrer">ESNU3K</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontainerCUC'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 16</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ILSW16.pdf" target="_blank" rel="noreferrer">ILS W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ILSX16.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ILSY16.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ILSZ16.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/VOR16.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/LOCZ16.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/RNP16.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 34</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/RNPA34.pdf" target="_blank" rel="noreferrer">RNP A</a></th>
          </tr>
          
          </table>
        </div>
      </div>

    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontainerCUC'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 03</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI7A.pdf" target="_blank" rel="noreferrer">DIMI7A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI7A.pdf" target="_blank" rel="noreferrer">TIBU7A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI7A.pdf" target="_blank" rel="noreferrer">TORA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC4D.pdf" target="_blank" rel="noreferrer">CUC4D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC4D.pdf" target="_blank" rel="noreferrer">TORA2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/UMPE1D.pdf" target="_blank" rel="noreferrer">UMPE1D</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 21</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2D.pdf" target="_blank" rel="noreferrer">DIMI2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2D.pdf" target="_blank" rel="noreferrer">TIBU2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2D.pdf" target="_blank" rel="noreferrer">TORA2L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC2E.pdf" target="_blank" rel="noreferrer">CUC2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/CUC2E.pdf" target="_blank" rel="noreferrer">TORA2M</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/UMPE2B.pdf" target="_blank" rel="noreferrer">UMPE2B</a></th>
          </tr>
            <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/UMPE2B.pdf" target="_blank" rel="noreferrer">UMPE2C</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontainerCUC'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 03</th>                      
          </tr>
          
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 21</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3A.pdf" target="_blank" rel="noreferrer">ESNU3A</a></th>
          </tr>
            <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3B.pdf" target="_blank" rel="noreferrer">ESNU3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3B.pdf" target="_blank" rel="noreferrer">UMPE2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2E.pdf" target="_blank" rel="noreferrer">DIMI2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2E.pdf" target="_blank" rel="noreferrer">ESNU2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI2E.pdf" target="_blank" rel="noreferrer">TIBU2E</a></th>
          </tr>      
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ESNU3K.pdf" target="_blank" rel="noreferrer">ESNU3K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI1G.pdf" target="_blank" rel="noreferrer">DIMI1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/DIMI1G.pdf" target="_blank" rel="noreferrer">TIBU1G</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontainerCUC'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 03</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/VORA2103.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 21</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ILSZ21.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/ILSY21.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/VORA2103.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/RNPA21.pdf" target="_blank" rel="noreferrer">RNP A</a></th>
          </tr>
          
          </table>
        </div>
      </div>

    </div>


    <div className='Espacio-titulo'>
    <p className='Guabito'>San Antonio de Táchira</p>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontainerCUC'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 17</th>                      
          </tr>  
         
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 35</th>                      
          </tr>
          
          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/LFA1A.pdf" target="_blank" rel="noreferrer">LFA1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/LFA1C.pdf" target="_blank" rel="noreferrer">LFA1C</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontainerCUC'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 17</th>                      
          </tr>
          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/LFA1B.pdf" target="_blank" rel="noreferrer">LFA1B</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 35</th>                      
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontainerCUC'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 17</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/VORA17.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKCC/RNAV17.pdf" target="_blank" rel="noreferrer">RNAV</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 35</th>                      
          </tr> 
          
          
          </table>
        </div>
      </div>

    </div>
  </div>
  );
};
export default Cucuta;